import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import LanguageToggle from "@/components/site/LanguageToggle";
import { useLanguage } from "@/contexts/LanguageContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8129d42d-fed9-4788-882a-4169a0f332c3/artifacts/jb8ymdb6_image.png";

export default function Navbar() {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#services", label: t("nav.services") },
    { href: "#hours", label: t("nav.hours") },
    { href: "#reviews", label: t("nav.reviews") },
    { href: "#location", label: t("nav.location") },
  ];

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-[rgba(212,175,55,0.18)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between py-3.5">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="Lopez Appliances"
            className="h-10 w-auto transition-transform duration-500 group-hover:scale-105"
          />
          <span className="hidden sm:inline-block font-serif-display text-[#d4af37] tracking-wider text-sm">
            EST. 1985
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`navlink-${l.href.slice(1)}`}
              className="relative text-[13px] tracking-[0.2em] uppercase text-white/80 hover:text-[#d4af37] transition-colors duration-300 after:content-[''] after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 hover:after:w-full after:bg-[#d4af37] after:transition-all after:duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <LanguageToggle />
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden p-2 text-[#d4af37]"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 border-t border-[rgba(212,175,55,0.2)]"
        >
          <div className="flex flex-col px-6 py-5 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] uppercase text-white/80 hover:text-[#d4af37]"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
